module.exports = __webpack_public_path__ + "img/r3.b7418b69.jpg";